import { RecoilState, useRecoilValue as useRecoilValueDefault } from 'recoil';

const useRecoilValue = <T>(atom: RecoilState<T>) => {
  const state = useRecoilValueDefault(atom);

  return state;
};

export default useRecoilValue;
